
import {aiApi} from './ai'

export const removeSocialAccountApi = aiApi.injectEndpoints({
  endpoints: (builder) => ({
    
    removeSocialAccount: builder.mutation({
      query: (accountId) => ({
        url: `/social/accounts/${accountId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['SocialAccount'],
    }),

  }),
  overrideExisting: false,
})

export const { useRemoveSocialAccountMutation } = removeSocialAccountApi